import {Button} from '@bosch/react-frok';
import React, {useEffect, useState} from 'react';
import {ActionBar, FileImages, PreviewWrapper} from './PreviewDialog.style';
import {DialogWrapper} from '../FileDetailsDialog/FileDetailsDialog.style';
import {StorageObject} from '../../../models/StorageObject';
import {t} from 'i18next';
import {getLabel} from '../../../utils/StorageObjectUtils';
import {useGetPreview} from '../../../hooks/UseGetPreview';
import {isFileDownloadable} from '../../../utils/DtoUtils';
import {executeAction, isNullOrEmpty} from '../../../utils';

export interface PreviewDialogProps {
    readonly item: StorageObject;
    readonly language: string;
    readonly defaultLocale: string;
    readonly previewDownloadUrl: string
    readonly editMode: boolean;
    editAction: () => void;
    deleteAction: () => void;
    downloadAction: () => void;
    onClose: () => void;
}

/**
 * @name PreviewDialog
 * @description
 * The dialog containing information to the file that has been clicked
 */
export const PreviewDialog: React.VFC<PreviewDialogProps> = (props) => {
    const getPreview = useGetPreview();
    const [previewUrl, setPreviewUrl] = useState(props.previewDownloadUrl);

    const setExistingPreview = async (id: string) => {
        let existingPreview = await getPreview(id);
        setPreviewUrl(existingPreview);
    };

    useEffect(() => {
        if ((props.item.id) && (!isNullOrEmpty(props.item.id))) {
            setExistingPreview(props.item.id).catch();
        }
    }, [props.item.id]);

    let label = getLabel(props.defaultLocale, props.item.labels);
    let isDownloadable = isFileDownloadable(props.item.status);

    return (
        <DialogWrapper
            key={props.item.id}
            modal
            open
            title={t('FILE_PREVIEW_DIALOG_TITLE')}
            headline={label.name ? label.name : t('GENERAL_UNKNOWN_CONTENT_TEXT')}
            headlineSpace={props.editMode}
            onClose={props.onClose}
            confirmButton={isDownloadable ?
                <Button key='download'
                        icon='download'
                        mode='primary'
                        type='button'
                        label={t('GENERAL_DOWNLOAD_LABEL')}
                /> : undefined}
            onConfirm={(e) => isDownloadable ? executeAction(e, props.downloadAction) : props.onClose}
        >
            {props.editMode && (
                <ActionBar
                    key={'command-bar'}
                    actions={[
                        <Button
                            key='edit'
                            icon='edit'
                            mode='tertiary'
                            type='button'
                            onClick={props.editAction}
                        />,
                        <Button
                            key='delete'
                            icon='delete'
                            mode='tertiary'
                            type='button'
                            onClick={props.deleteAction}
                        />
                    ]}
                />
            )}

            <PreviewWrapper>
                <FileImages src={previewUrl} alt={'preview not found'}/>
            </PreviewWrapper>
        </DialogWrapper>
    );
};
